import { Color } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-color}
 *
 * @internal
 */
export default Longhand.of(Color.current, Color.parse, (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=text-decoration-color.js.map